import { Link } from "gatsby"
import RichText from "../rich-text/renderer"
import { sidebar, link } from "@templates/press.module.css"
import { arrowLeft, base, text } from "../button.module.css"
import { MikanSpan } from "../Mikan"
import { usePressSidebar } from "@hooks/use-press-sidebar"

const PressSidebar = ({ redirect, pageMenu }) => {
  const redirectName = pageMenu && pageMenu.find((link) => link.url === redirect)
  const data = usePressSidebar()
  const content = data.sidebar.rtContent

  return (
    <div className={sidebar}>
      {redirect && (
        <Link className={`${link} ${arrowLeft} ${base} ${text}`} to={redirect}>
          <MikanSpan text={data.backText.text} /> {redirectName["name"].toLowerCase()}
        </Link>
      )}
      <RichText body={content} mikan={data.sidebar.mikan} />
    </div>
  )
}

export default PressSidebar
